<template>
	<LayoutMain>
		<div class="navsecondary" v-if="this.$route.params.customerid">
			<a v-if="false" href="findorderanchor" :class="{ 'active' : findcontainershown }" @click.prevent="toggleFindContainer" data-ic="Q">
				<span>Find bestilling</span>
			</a>
			<RouterLink data-ic="3" v-if="this.$route.params.customerid" :to="{ name: 'OrderSendWebshopLinks', params: { customerid: this.$route.params.customerid, persongroupid: this.$route.params.persongroupid }}">
				<span>Send webshop links</span>
			</RouterLink>
		</div>
		<transition name="fade">
			<div class="navtools" ref="findcontainer" v-if="findcontainershown">
				<form>

					<div class="form-groups">
						<div class="form-group">
							<div class="input-group">
								<input v-model="findorderinput" ref="findorderinputelement" type="text" placeholder="Indtast navn eller en del af et navn, e-mail, mobilnummer, ordrenummer eller transaktions ID">
							</div>
						</div>

						<div class="buttons-group">
							<button class="small" @click.prevent="findOrder">Søg</button>
							<button class="text small" @click.prevent="toggleFindContainer">Nulstil</button>
						</div>
					</div>

				</form>
			</div>
		</transition>
		<section>
			<a class="backlink" ref="backlink" v-if="selection.customername && !isFind" data-ic="Y" @click.prevent="goBack"></a>

			<h1>{{ title }}</h1>

			<ul class="tabs" v-if="!isFindResult">
				<li>
					<RouterLink :to="{ name: 'Orders' }">
						Ordre
					</RouterLink>
				</li>
				<li>
					<RouterLink :to="{ name: 'OrdersByCustomer' }" :class="{'active': isInstitutionSubPage}">
						Institutioner
					</RouterLink>
				</li>
			</ul>

			<div>
				<transition name="fade">
					<RouterView :key="$route.name" :search="searchinput" :findorderinput="findorderinput" :section="section" :selection="selection" @update="onChildUpdate" />
				</transition>
			</div>
		</section>
	</LayoutMain>
</template>

<script>
	import LayoutMain from "@/components/common/LayoutMain.vue";
	import { types } from "@/app/types/types";

	export default {
		name: "Orders",
		data()
		{
			return {
				searchinput: "",
				section: "orders",
				agreementID: 0,
				customerID: 0,
				persongroupID: 0,
				selection: {
					customername: "",
					groupname: ""
				},
				title: "Bestillinger",
				findcontainershown: false,
				findorderinput: null,
				isInstitutionSubPage: false
			}
		},
		beforeRouteUpdate(to, from, next)
		{
			this.isInstitutionSubPage = this.checkIsInstitutionSubPage(to)

			if (to.name == "Orders" || to.name == "OrdersPersonGroups" || to.name == "OrdersPersonGroupShow")
			{
				if (this.findcontainershown)
				{
					this.toggleFindContainer()
				}
			}

			next()
		},
		created()
		{
			this.agreementID = this.$route.params.agreementid
			this.customerID = this.$route.params.customerid
			this.persongroupID = this.$route.params.persongroupid
			this.findorderinput = this.$route.params.findorderinput
			this.findcontainershown = this.$route.name == "FindOrdersResult"
		},
		computed:
		{
			isFind()
			{
				return this.$route.name == "FindOrdersResult" || this.findcontainershown
			},

			isFindResult()
			{
				return this.$route.name == "FindOrdersResult"
			}
		},
		async beforeUpdate()
		{
			if (this.selection == null)
			{
				this.selection = { customername: "", groupname: "", agreementname: "" }
			}

			if (this.$route.name == "Orders")
			{
				this.title = "Bestillinger"
				this.selection = { customername: "", groupname: "", agreementname: "" }
			}
			else if (this.$route.name == "OrdersPersonGroups" && this.selection.customername == "")
			{
				this.setAppAsBusyModal();
				var result = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID);

				if (result.status == 200)
				{
					this.selection.customername = result.data.name
				}
				else
				{
					this.title = "Bestillinger"
				}

				this.onChildUpdate(this.selection)
				this.setAppAsIdle()
			}
			else if (this.$route.name == "OrdersPersonGroups" && (!this.selection || !this.selection.agreementname || this.selection.agreementname == ""))
			{
				if (!this.agreementID)
				{
					this.agreementID = this.$route.params.agreementid
				}

				this.setAppAsBusyModal();
				var result = await this.$store.dispatch(types.ACTION_GET_AGREEMENT, this.agreementID);

				if (result.status == 200)
				{
					this.selection.agreementname = result.data.name
				}
				else
				{
					this.title = "Bestillinger"
				}

				this.onChildUpdate(this.selection)
				this.setAppAsIdle()
			}
			else if (this.$route.name == "FindOrdersResult")
			{
				this.title = "Søge resultat"
			}
		},
		methods:
		{
			checkIsInstitutionSubPage(targetRoute)
			{
				let ordersByCustomerRoute = this.$router.resolve({ name: "OrdersByCustomer" })
				return ordersByCustomerRoute && targetRoute.path.startsWith(ordersByCustomerRoute.route.path)
			},
			goBack()
			{
				this.agreementID = this.$route.params.agreementid
				this.customerID = this.$route.params.customerid
				this.persongroupID = this.$route.params.persongroupid
				this.toggleFindContainer(true)

				if (this.agreementID && this.customerID && this.persongroupID)
				{
					this.$router.push({ name: "OrdersPersonGroups", params: { agreementid: this.agreementID, customerid: this.customerID } })
				}
				else if (this.agreementID && this.customerID)
				{
					this.$router.push({ name: "Orders" })
				}
			},
			findOrder()
			{
				if (!this.findorderinput)
				{
					alert("Indtast venligst en del af et navn, e-mail, mobilnummer eller ordrenummer");
					return;
				}
				else if (this.findorderinput && this.findorderinput.length < 3)
				{
					alert("Indtast venligst en søge tekst på minimum 2 karakterer");
					return;
				}

				this.agreementID = this.$route.params.agreementid
				this.customerID = this.$route.params.customerid
				this.persongroupID = this.$route.params.persongroupid
				this.$router.push({ name: "FindOrdersResult", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID, findorderinput: this.findorderinput } })
			},
			toggleFindContainer(hide)
			{
				this.findcontainershown = !this.findcontainershown

				if (!this.findcontainershown || hide == true)
				{
					this.findcontainershown = false
					this.findorderinput = null
					this.agreementID = this.$route.params.agreementid ? this.$route.params.agreementid : null
					this.customerID = this.$route.params.customerid ? this.$route.params.customerid : null
					this.persongroupID = this.$route.params.persongroupid ? this.$route.params.persongroupid : null

					if (this.persongroupID)
					{
						this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID } })
					}
					else if (this.agreementid && this.customerID)
					{
						this.$router.push({ name: "OrdersPersonGroups", params: { agreementid: this.agreementID, customerid: this.customerID } })
					}
					else
					{
						this.$router.push({ name: "Orders" })
					}
				}
				else
				{
					this.$nextTick(() => this.$refs.findorderinputelement.focus())
				}
			},
			onChildUpdate(selection)
			{
				if (selection)
				{
					if (this.selection != null)
					{
						this.selection.customername = (selection.customername ? selection.customername : this.selection.customername);
						this.selection.groupname = (selection.groupname ? selection.groupname : null);
						this.selection.agreementname = (selection.agreementname ? selection.agreementname : this.selection.agreementname);
					}
					else
					{
						this.selection = selection
					}

					this.title = "Bestillinger for " + (this.selection.groupname ? this.selection.groupname + " på " : "") + this.selection.customername;

					if (this.selection.agreementname)
					{
						this.title += ", " + this.selection.agreementname
					}
				}
				else
				{
					this.selection = {
						customername: "",
						groupname: ""
					}

					this.title = "Bestillinger"
				}
			}
		},
		components:
		{
			LayoutMain
		}
	};
</script>